import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, signal } from '@angular/core';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toast.scss',
})
export class Toast {
  protected readonly show = signal(false);
  protected readonly message = signal('');
  protected readonly typeClass = signal('toast-info');

  showToast(message: string, type: string = 'success', duration: number = 3000): void {
    this.message.set(message);
    this.typeClass.set(`toast-${type}`);
    this.show.set(true);

    setTimeout(() => {
      this.hideToast();
    }, duration);
  }

  hideToast(): void {
    this.show.set(false);
  }
}
